export default {
    titulo: "Compras",
    nueva: "Nueva compra",
    buscar: "Buscar por documento, proveedor o número de parte",
    eliminar: "Eliminar compra",
    pregEliminar: "¿Confirmas que deseas eliminar la compra?",
    editar: "Editar compra",
    tipoDocumento: "Tipo de documento",
    ventaIgualCompra: "Establecer precio de venta igual a precio de compra",
    observaciones: "Observaciones",
    subtotal: "Subtotal",
    descuento: "Descuento",
    iva: "Impuesto",
    redondeo: "Redondeo",
    total: "Total",
    contado: "Contado",
    credito: "Crédito",
    notaCred: "Nota de crédito",
    devolucion: "Devolución contado",
    msgRepuestos: "Agrega al menos un repuesto para continuar",
    msgImpuestos: "Asigna un impuesto válido a todos los repuestos para continuar",
    msgDuplicado: "Repuesto duplicado",
    msgCantidad: "Ingresa una cantidad válida",
}